<template>
    <div class="container-fluid search" id="search">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="row mb-4">
                    <div class="col-md-12">
                        <div v-if="loggedInUser.has_active_recommends" class="view-recommend-link d-block d-md-none">
                            <a :href="`/recommended`">
                                <span class="icon">
                                    <img :src="'images/favourites-full.svg'">
                                    <!--                                        src="{!!asset('images/favourites-full.svg')!!}" alt="Recommended">-->
                                </span>
                                View your recommended vehicles
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-between">
                    <div class="container-search col-xl-6 col-lg-12 col-md-12 col-sm-12">
                        <h2>Search Auctions</h2>
                        <vehicle-search-form ref="searchForm" :past="past"></vehicle-search-form>
                        <div class="saved-searches">
                            <div class="container-buttons">
                                <div class="form-group inline-label">
                                    <label for="saveSearch"><span>Saved Search</span></label>
                                    <input type="text" id="saveSearch" placeholder="Saved Search" class="form-control"
                                           v-model="searchName" @change="onChangeName">
                                </div>
                                <a href="#" class="btn btn-primary" @click="submit">
                                    Save Search
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 container-auction-days" v-if="!past">
                        <h2>Auction Days</h2>
                        <div class="auction-days">
                            <div class="block-auction-days" v-for="(counters, date) in dateCounters">
                                <div class="checkbox">
                                    <input type="checkbox"
                                           :id="'checkbox-day-'+date"
                                           v-model="dates[date]"
                                           @change="onChangeDate"
                                    />
                                    <label :for="'checkbox-day-'+date" @click="selectAll(date)"></label>
                                    <span class="title-day arrow-right" v-on:click="openAuctionDate(date,$event)">
                                        {{ convertDateIntoFullText(date) }}
                                    </span>
                                </div>
                                <div class="diff">{{ getDiffJapanTime(date) }}</div>
                                <div class="links">
                                    <span class="link" @click="goToAuctionDay(date)">Browse {{ counterTotal(counters) }} items</span>
                                    <span class="link" @click="goToFavouriteDay(date)">Favourites</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 container-auction" v-if="!past && canViewAuctions">
                        <h2>Auction House</h2>
                        <h2 class="d-xs-none d-sm-none">Auctions</h2>
                        <ul class="list-day">
                            <li class="item-list-day" v-for="(counters, date) in dateCounters">
                                <div class="active">

                                    <div class="day">
                                        <span class="title-day arrow-right" v-on:click="openAuctionDate(date,$event)">
                                            {{ convertDateIntoDayName(date) }} ({{ date }})
                                        </span>
                                    </div>
                                    <ul class="list-auctions" :id="'list-auction-'+date">

                                        <li class="item-list-auction" v-for="counter in counters">
                                            <div class="auction-detail">
                                                <input type="checkbox"
                                                       :key="counter.auction_house.slug+'-'+date"
                                                       :name="generateNameString('auction_dates', date, counter.auction_house.value)"
                                                       :id="'checkbox-auction-'+counter.auction_house.slug+'-'+date"
                                                       :value="counter.auction_house.value"
                                                       @change="counterChecked($event, date, counter)"
                                                       v-model="auctions[counter.auction_house.slug+'-'+date]">

                                                <label :for="'checkbox-auction-'+counter.auction_house.slug+'-'+date">
                                                    {{ counter.auction_house.name }}
                                                    <span class="number">({{ counter.count }})</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12" v-else>
                        <template v-if="past">
                            <label for="auction_date"><span>Past auction date</span></label>
                            <b-form-input type="date" v-model="past_auction_date"
                                          id="past-auction-date"
                                          placeholder="Enter auction date" name="auction_date" required
                                          @change="onPastAuctionDateChange"></b-form-input>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import searchMixin from '../mixins/VehicleSearch.vue';
import {mapState, mapMutations} from 'vuex'
import {objToUrl, storeLocalData, getLocalData, getNZDateTime} from "../util/common";
// import moment from "moment-timezone";

export default {
    props: ['past'],
    mixins: [
        ''
    ],
    created() {
        //generate the years
        /* this.years = [
            '2006'
        ]; */

        const isFromSessionStorage = this.$store.getters['auction_search/isFromSessionStorage']
        if (isFromSessionStorage) {
            this.auctions = this.$store.getters['auction_search/selected_auctions']
        }
        const selectedDates = this.$store.getters['auction_search/selected_dates_object']
        if (isFromSessionStorage && selectedDates) {
            this.dates = selectedDates
        } else {
            const date = window.moment().tz('Asia/Tokyo').format('YYYY-MM-DD');
            const setDates = {};
            setDates[date] = true;
            this.dates = setDates;
            this.setSelectedDates([date]);
        }
        this.getData(false, isFromSessionStorage)
    },
    data() {
        return {
            searchName: '',
            dates: {},
            currentDate: '',
            auctions: {},
            selectedModels: {},
            modelList: [],
            excludedMakes: {},
            model_active: false,
            showModelModal: false,
            showExludeMakesModal: false,
            past_auction_date: '',
        }
    },
    computed: {
        ...mapState({
            dateCounters: state => state.auction_search.date_counters,
            data: state => state.auction_search.search_data,
            selected_models: state => state.auction_search.selected_models,
            loading: state => state.auction_search.loading,
        }),
        canViewAuctions() {
            if (this.loggedInUser.privileges.show_auction_site) {
                return true
            }
            return false
        }
    },
    methods: {
        ...mapMutations({
            setSearch: 'auction_search/setSearch',
            setSearchProperty: 'auction_search/setSearchProperty',
            setSelectedAuctions: 'auction_search/setSelectedAuctions',
            setSelectedDates: 'auction_search/setSelectedDates',
        }),
        onChangeName() {
            this.setSearchProperty({
                prop: 'name',
                value: this.searchName
            })
        },
        onPastAuctionDateChange() {
            this.setSearchProperty({
                prop: 'past_auction_date',
                value: this.past_auction_date
            })
        },
        async getData(fresh = true, firstLoad = false) {
            if (fresh) {
                await this.$store.dispatch('auction_search/getSearchData');
            } else {
                await this.$store.dispatch('auction_search/maybeGetSearchData');
                if (!this.$_.isEmpty(this.$route.query) && (this.$route.query.dates || this.$route.query.auction_houses)) {
                    let auctions = this.$route.query.auction_houses.split(',');
                    let today = moment().format('YYYY-MM-DD');
                    let dates = this.$route.query.dates ? this.$route.query.dates.split(',') : false
                    let selected = {};
                    auctions.forEach(auc => {
                        if (dates) {
                            dates.forEach(date => {
                                selected[`${auc}-${date}`] = true;
                            })
                        } else {
                            selected[`${auc}-${today}`] = true;
                        }
                    })
                    this.auctions = selected;
                    this.setSelectedAuctions(selected);
                    if (dates) {
                        this.setSelectedDates(dates);
                    }
                } else if (!firstLoad) {
                    let dates = this.getActiveDates()
                    dates.forEach(date => {
                        this.selectAll(date, true)
                    })
                }
            }
        },
        submit() {
            let data = JSON.parse(JSON.stringify(this.data));
            if (data['id']) {
                delete data['id'];
            }
            if (Object.keys(this.selected_models).length) {
                let models = ''
                let i = 0
                for (let make in this.selected_models) {
                    if (i > 0) {
                        models += '|';
                    }
                    let n = 0;
                    for (let model in this.selected_models[make]) {
                        if (this.selected_models[make][model]) {
                            if (n > 0) {
                                models += ',';
                            }
                            models += model;
                            n++
                        }
                    }
                    i++;
                }
                data.model = models
            }
            this.$store.dispatch('saved_searches/saveSearch', data).then(result => {
                if (result) {
                    this.$message.success('Your search has been saved.');
                } else {
                    this.$message.error('There was a problem saving your search.');
                }
            }).catch(err => {
                console.warn(err);
                this.$message.error('There was a problem saving your search.');
            });
        },
        objectToString(object) {
            let array = this.objToArray(object);
            return array.join();
        },
        objToArray(object) {
            let array = [];
            for (const key of Object.keys(object)) {
                if (object[key]) {
                    array.push(key);
                }
            }
            return array;
        },
        generateNameString(name, ...args) {
            let name_string = name;
            this.$_.each(args, item => {
                name_string = name_string + '[' + item + ']';
            });
            return name_string;
        },
        /**
         * Only give the field a name if the value is populated
         * @param fieldname
         * @param value
         */
        getNameField(fieldname, value) {
            /**
             * Check if its in the data obj
             */
            if (this.data[fieldname]) {
                return fieldname;
            }
            if (!this.$_.isEmpty(value)) {
                return fieldname;
            }
            return '';
        },
        getActiveDates() {
            let dates = [];
            for (let date in this.dates) {
                if (this.dates[date]) {
                    dates.push(date);
                }
            }
            return dates;
        },
        counterChecked(checked, date, counter) {
            this.setSelectedAuctions(this.auctions);
            let date_selected = checked.target.checked
            if (!date_selected) {
                let found = false;
                for (let auc in this.auctions) {
                    if (auc !== `${counter.auction_house.value}-${date}` && auc.includes(date)) {
                        found = true
                    }
                }
                date_selected = found
            }
            this.dates[date] = date_selected
            this.setSelectedDates(this.getActiveDates());
            this.setSelectedAuctions(this.auctions)
        },
        counterTotal: function (counters) {
            let total = 0;
            for (var i = 0; i < counters.length; i++) {
                total += parseInt(counters[i].count);
            }
            return total;
        },
        convertDateIntoDayName(data) {
            return window.moment(data).format('dddd')
        },
        convertDateIntoFullText(data) {
            return window.moment(data).format('dddd MMMM, D')
        },
        openAuctionDate(date, event) {
            this.currentDate = date;
            this.saveAuctions();
        },
        onChangeDate() {
            let dates = this.getActiveDates();
            this.$store.commit('auction_search/setSelectedDates', dates);
            this.getData(true);
        },
        selectAll(date, force = null) {
            let set_value;
            if (force !== null) {
                set_value = force;
            } else {
                set_value = !this.dates[date];
            }
            let auctions = {...this.auctions};
            if (this.dateCounters[date]) {
                this.dateCounters[date].forEach(item => {
                    //auctions[counter.auction_house.slug+'-'+date]
                    auctions[item.auction_house.slug + '-' + date] = set_value;
                });
            }
            this.auctions = auctions;
            this.setSelectedAuctions(auctions);
            this.getData(true);
        },
        clearForm() {
            this.dates = {};
            this.auctions = {};
            let date = window.moment().format('YYYY-MM-DD');
            this.selectAll(date, true);
            this.selectedModels = {};
            this.excludedMakes = {};
            this.$refs.searchForm.clearForm();
        },
        goToAuctionDay(date) {
            this.$store.commit('auction_search/setCurrentPage', 1)
            let base_url = this.$laravelRouter('search-vehicle', [], false);
            let url = base_url + '?date=' + date;
            this.axios.get(url);
            this.$router.push(url);
        },
        goToFavouriteDay(date) {
            let url = window.location.origin + '/favourites?date=' + date;
            window.location.href = url;
        },
        getDiffJapanTime(date) {
            let jap_now = window.moment.tz('Asia/Tokyo')
            let start = window.moment.tz(`${date} 08:00`, 'Asia/Tokyo')
            let end = window.moment.tz(`${date} 17:00`, 'Asia/Tokyo')
            let diff = jap_now.diff(start, 's');
            let string = '';
            if (jap_now > end) {
                return 'Completed'
            }
            if (diff) {
                let left = Math.abs(diff);
                let timeframes = {
                    'day': 86400,
                    'hr': 3600,
                    'min': 60,
                }
                for (let t in timeframes) {
                    let val = Math.round(left / timeframes[t]);
                    if (val > 0) {
                        string += ' ' + val + ' ' + t
                        if (val > 1) {
                            string += 's'
                        }
                        left = start % timeframes[t]
                    }
                }
                if (jap_now < end && jap_now > start) {
                    string = 'Started ' + string + ' ago'
                } else {
                    string = string + ' from now'
                }
            }
            return string;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleSearch.vue